/* 公司管理 */
const layoutComponent = () => import('@/views/layout')

export default [
  {
    path: '/companyManagement',
    component: layoutComponent,
    meta: {
      title: 'menu.companyManagement',
      icon: 'el-icon-ali-CompanyManagement'
    },
    children: [
      {
        path: '/companyManagement/companyManagementIndex',
        name: 'companyManagement',
        component: () => import('@/views/companyManagement/companyManagementIndex.vue'),
        meta: {
          title: 'menu.updateCompanyInfo',
          buttons: [
            { code: 'scan', name: '浏览' },
            { code: 'edit', name: '编辑' },
            { code: 'view', name: '查看' },
            { code: 'generate', name: '生成' },
            { code: 'viewProcess', name: '查看过程' },
            { code: 'editProcess', name: '编辑过程' }
          ]
        }
      },
      {
        path: '/companyManagement/companyListView',
        name: 'companyListView',
        component: () => import('@/views/companyManagement/companyListView.vue'),
        meta: {
          title: 'menu.companyManagement',
          buttons: [
            { code: 'scan', name: '浏览' },
            { code: 'add', name: '新增' },
            { code: 'delete', name: '删除' },
            { code: 'edit', name: '编辑' },
            { code: 'view', name: '查看' },
            { code: 'enable', name: '启用' },
            { code: 'disable', name: '禁用' },
            { code: 'import', name: '导入' },
            { code: 'generate', name: '生成' },
            { code: 'viewProcess', name: '查看过程' },
            { code: 'editProcess', name: '编辑过程' }
          ]
        }
      },
      {
        path: '/companyManagement/companyInformationView',
        name: 'companyInformationView',
        component: () => import('@/views/companyManagement/companyInformationView'),
        meta: {
          title: 'menu.companyInformationView',
          routeNameParent: 'companyManagement'
        }
      },
      {
        path: '/companyManagement/companyInfoView',
        name: 'companyInfoView',
        component: () => import('@/views/companyManagement/companyInfoView'),
        meta: {
          title: 'menu.companyInfoView',
          routeNameParent: 'companyManagement'
        }
      },
      {
        path: '/companyManagement/companyProcessView',
        name: 'companyProcessView',
        component: () => import('@/views/companyManagement/companyProcessView'),
        meta: {
          title: 'menu.companyProcessView',
          routeNameParent: 'companyManagement'
        }
      },
      {
        path: '/companyManagement/companyProcessEdit',
        name: 'companyProcessEdit',
        component: () => import('@/views/companyManagement/companyProcessEdit'),
        meta: {
          title: 'menu.companyProcessEdit',
          routeNameParent: 'companyManagement'
        }
      },
      {
        path: '/companyManagement/companyProcessListView',
        name: 'companyProcessListView',
        component: () => import('@/views/companyManagement/companyProcessListView'),
        meta: {
          title: 'menu.companyProcessListView',
          routeNameParent: 'companyListView'
        }
      },
      {
        path: '/companyManagement/companyProcessListViewView',
        name: 'companyProcessListViewView',
        component: () => import('@/views/companyManagement/companyProcessListViewView'),
        meta: {
          title: 'menu.companyProcessListView',
          routeNameParent: 'companyListView'
        }
      },
      {
        path: '/companyManagement/companyProcessEditInList',
        name: 'companyProcessEditInList',
        component: () => import('@/views/companyManagement/companyProcessEdit'),
        meta: {
          title: 'menu.companyProcessEdit',
          routeNameParent: 'companyListView',
          routeNamePrevious: 'companyProcessListView'
        }
      },
      {
        path: '/companyManagement/companyProcessViewInList',
        name: 'companyProcessViewInList',
        component: () => import('@/views/companyManagement/companyProcessView'),
        meta: {
          title: 'menu.companyProcessView',
          routeNameParent: 'companyListView',
          routeNamePrevious: 'companyProcessListView'
        }
      },
      {
        path: '/companyManagement/companyInformationViewInList',
        name: 'companyInformationViewInList',
        component: () => import('@/views/companyManagement/companyInformationView'),
        meta: {
          title: 'menu.companyInformationView',
          routeNameParent: 'companyListView'
        }
      },
      {
        path: '/companyManagement/companyInfoViewInList',
        name: 'companyInfoViewInList',
        component: () => import('@/views/companyManagement/companyInfoView'),
        meta: {
          title: 'menu.companyInfoView',
          routeNameParent: 'companyListView'
        }
      },
      {
        path: '/companyManagement/PdfPageView',
        name: 'companyInfoViewInList',
        component: () => import('@/views/homes/pdfPage'),
        meta: {
          title: 'menu.companyInfoView',
          routeNameParent: 'companyListView'
        }
      }
    ]
  }
]
